<template>
  <div>
    <div class="sidebar-section">
      <div class="section-logo float-to-left p__t--25 p__l--40 p__b--55">
        <b-img
          :src="require('@/assets/logo-dashboard.svg')"
          fluid
          alt="Fluid image"
        ></b-img>
      </div>

      <div class="section-profile p__t--25">
        <div class="float-to-center">
          <b-img
            :src="require('@/assets/logo-user.png')"
            rounded="circle"
            height="70"
            alt="Circle image"
          ></b-img>
        </div>
        <h3 class="text-center m__t--8 m__b--0">
          {{ profile.title ? profile.title : '' }}
        </h3>
        <p class="text-center">
          {{ profile.role ? profile.role : '' }}
        </p>
      </div>

      <div class="section-menu p__t--15">
        <span v-for="(menu, index) in menus" :key="index">
          <div
            class="layer-one p--5 p__l--40 p__r--20 cursor-pointer"
            v-if="typeof menu.isAppear === 'boolean' ? menu.isAppear : true"
          >
            <div role="tab">
              <div
                @click="openMenu(menu)"
                :class="{ active: $route.path.includes(menu.path) }"
              >
                <i :class="menu.logo" class="m__r--10"></i>
                <span class="hidden-item">{{ menu.name }}</span>
                <i
                  v-if="menu.children"
                  class="fa float-right p--10"
                  :class="
                    !menu.isShow ? 'fa fa-angle-right' : 'fa fa-angle-down'
                  "
                ></i>
              </div>
            </div>

            <b-collapse
              v-if="menu.children"
              v-model="menu.isShow"
              class="mt-2"
              accordion="my-accordion"
              role="tablist"
            >
              <div
                v-for="(item, index2) in menu.children"
                :key="index2"
                class="p--5 m__l--10"
                :class="{ active: $route.path.includes(item.path) }"
              >
                <i :class="item.logo" class="m__r--10"></i>
                <span class="hidden-item">{{ item.name }}</span>
              </div>
            </b-collapse>
          </div>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
  name: 'index-login',
  computed: {
    ...mapState('StoreLoading', ['loading_state'])
  },
  props: {
    options: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      profile: JSON.parse(localStorage.getItem('user')) || {
        title: 'Pandu',
        role: 'SUPERADMIN'
      },
      menus: [
        {
          path: '/home/dashboard',
          logo: 'fa fa-home',
          name: 'Dashboard',
          isShow: false,
          children: [
            {
              path: '/home/dashboard/account',
              logo: 'fa fa-user',
              name: 'Account'
            },
            {
              path: '/home/dashboard/location',
              logo: 'fa fa-location-arrow',
              name: 'Location'
            }
          ]
        },
        {
          path: '/home/package',
          logo: 'fa fa-box',
          name: 'Package Travel',
          isShow: false,
          children: [
            {
              path: '',
              logo: 'fa fa-times-circle',
              name: 'List'
            },
            {
              path: '',
              logo: 'fa fa-times-circle',
              name: 'Add'
            }
          ]
        },
        {
          path: '/home/setting',
          logo: 'fa fa-cog',
          name: 'Setting',
          isShow: false
        }
      ]
    };
  },
  created() {
    this.menus = this.options;
  },
  methods: {
    openMenu(data) {
      if (data.children) {
        data.isShow = !data.isShow;
      } else {
        this.$router.replace(data.path);
      }
    }
  }
};
</script>

<style lang="scss">
.sidebar-section {
  overflow: scroll;
  height: 100%;
  width: 300px;
  background: #1d2d4e;
  position: fixed;
  .active {
    color: #0095e9;
  }
  .section-profile {
    border: 1px solid #17243f;
    h3 {
      font-style: normal;
      font-weight: bold;
      font-size: 20px;
      line-height: 37px;
      color: #fff;
    }
    p {
      color: #fff;
      font-style: normal;
      font-weight: normal;
      font-size: 16px;
      line-height: 37px;
    }
  }
  .section-menu {
    color: white;
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 37px;
  }
}

@media only screen and (max-width: 850px) {
  .sidebar-section {
    width: 80px;

    img {
      height: 50px;
    }
    h3 {
      font-size: 14px !important;
    }
    p {
      font-size: 12px !important;
    }
    .hidden-item {
      display: none;
    }
    .layer-one {
      padding-left: 29px !important;
    }
    .section-logo.float-to-left.p__t--25.p__l--40.p__b--55 {
      padding: 10px !important;
    }
  }
}
</style>
